import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import PeerInvestDatePicker from './PeerInvestDatePicker';

const useStyles = makeStyles({
  container: {
    marginTop: 5
  },
  table: {
    minWidth: '100%'
  },
  trashIcon: {
    cursor: 'pointer'
  }
});

const TableCellTitleStrong = withStyles((theme) => ({
  head: {
    fontSize: 14,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const PeersTable = ({ options, onClickDelete, since, setSince }) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.container} component={Paper}>
      <Table aria-label="a dense table" className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <TableCellTitleStrong>Peer Name</TableCellTitleStrong>
            <TableCellTitleStrong align="left">Since</TableCellTitleStrong>
            <TableCellTitleStrong align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {options.map((option) => (
            <TableRow key={option}>
              <TableCell component="th" scope="row">
                {option}
              </TableCell>
              <TableCell align="right">
                <PeerInvestDatePicker setSince={setSince} since={since} />
              </TableCell>
              <TableCell align="right">
                <DeleteOutlineIcon
                  className={classes.trashIcon}
                  color="error"
                  fontSize="small"
                  onClick={() => onClickDelete(option)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PeersTable;
